import { ReactElement } from 'react';

import { formatDate } from 'app/utils';
import { ButtonIcon, Flex, Section, Tooltip, Typography } from 'components';
import { useBreakpoints } from 'app/hooks';

const B3Footer = (): ReactElement => {
  const breakpoint = useBreakpoints();

  return (
    <Flex bg="gray_400" py={{ m: 4, d: 7 }}>
      <Section flexDirection="column" style={{ gap: breakpoint === 'mobile' ? 3 : 14 }}>
        <a href="https://www.b3.com.br/pt_br/termos-de-uso-e-protecao-de-dados/termos-de-uso/" target="_blank" rel="noreferrer">
          <Typography as="span" type="type1" color="white80" colorHover="white">
            Termos de Uso e Privacidade
          </Typography>
        </a>

        <a
          href="https://atendimento.b3.com.br/atendimento?id=kb_category_b3&kb_category=d27d91611b0f1514386da68fe54bcba2&kb_id=f2c2829f1b3d1050b9da23853a4bcbb5&utm_medium=site&utm_source=atendimento&utm_campaign=sac"
          target="_blank"
          rel="noreferrer"
        >
          <Typography as="span" type="type1" color="white80" colorHover="white">
            Atendimento
          </Typography>
        </a>

        <Flex justifyContent="space-between" mt={{ m: 4, d: 6 }}>
          <Flex flexGrow={0} style={{ gap: 16 }}>
            <a href="https://www.facebook.com/SomosB3/" rel="noreferrer" target="_blank">
              <Tooltip content="Facebook">
                <ButtonIcon icon="facebook" bg="transparent" color="white" colorHover="primary_400" iconWidth={22} />
              </Tooltip>
            </a>

            <a href="https://br.linkedin.com/company/b3_oficial" rel="noreferrer" target="_blank">
              <Tooltip content="LinkedIn">
                <ButtonIcon icon="linkedin" bg="transparent" color="white" colorHover="primary_400" iconWidth={22} />
              </Tooltip>
            </a>

            <a href="https://www.instagram.com/b3_oficial/" rel="noreferrer" target="_blank">
              <Tooltip content="Instagram">
                <ButtonIcon icon="instagram" bg="transparent" color="white" colorHover="primary_400" iconWidth={22} />
              </Tooltip>
            </a>

            <a href="https://mobile.twitter.com/b3_oficial" rel="noreferrer" target="_blank">
              <Tooltip content="Twitter">
                <ButtonIcon icon="twitter" bg="transparent" color="white" colorHover="primary_400" iconWidth={22} />
              </Tooltip>
            </a>

            <a href="https://www.youtube.com/user/bmfbovespa" rel="noreferrer" target="_blank">
              <Tooltip content="Youtube">
                <ButtonIcon icon="youtube" bg="transparent" color="white" colorHover="primary_400" iconWidth={22} />
              </Tooltip>
            </a>
          </Flex>

          <Flex flexGrow={0} mt={{ m: 3, d: 0 }}>
            <Typography type="type1" color="white80" colorHover="white">
              © B3 Educação {formatDate().format('Y')}
            </Typography>
          </Flex>
        </Flex>
      </Section>
    </Flex>
  );
};

export default B3Footer;

/*
Termos de Uso e Privacidade: 
: 
 
Facebook: 
Linkedin: 
Instagram: 
Twitter (X): 
Youtube: 
*/
